import axios from "axios";
import config from "src/config";

const URLVALIDATEUSER = config.url.URLVALIDATEUSER;
const URLVALIDATEUSERVISIBLE = config.url.URLVALIDATEUSERVISIBLE;
const URLRETRYBIOMETRICS = config.url.URLRETRYBIOMETRICS;
const URLPREVALIDATE = config.url.URLPREVALIDATE;

export const UsersAPI = {
  async validate(contextData, usersData, challenge) {
    try {
      const urlService = challenge ? URLVALIDATEUSERVISIBLE : URLVALIDATEUSER;
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie,
            'recaptcha': contextData.recaptcha
          }
      const response = await axios.post(urlService, usersData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateRetry(contextData, usersData) {
    try {
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie
          }
      const response = await axios.post(URLRETRYBIOMETRICS, usersData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async prevalidate(contextData, usersData) {
    try {
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie
          }
      const response = await axios.post(URLPREVALIDATE, usersData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};
